import { render, staticRenderFns } from "./setForm.vue?vue&type=template&id=b12fadde&"
import script from "./setForm.vue?vue&type=script&lang=ts&"
export * from "./setForm.vue?vue&type=script&lang=ts&"
import style0 from "./setForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports